module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 2.27198","quantity":0.02272},{"color":"#9dc4b5","label":" 2.27198- 2.44466","quantity":0.02445},{"color":"#e6efc3","label":" 2.44466- 2.91979","quantity":0.0292},{"color":"#ffe89e","label":" 2.91979- 3.73104","quantity":0.03731},{"color":"#f5af7f","label":" 3.73104- 5.05865","quantity":0.05059},{"color":"#ed6d32","label":" 5.05865- 18.95734","quantity":0.18957}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_80_return_20.json
// module id = f3I0
// module chunks = 171